export const EMAILS = "emails";
export const EMAIL_MODULES = "emailModules";
export const EMAIL_TEMPLATES = "emailTemplates";
export const IMAGES = "images";
export const CAMPAIGNS = "campaigns";
export const CAMPAIGNS_BY_PARENT = "campaignsByParent";
